import React from 'react';
import { useRealtime } from '../../contexts/RealtimeContext';
import StudentManagement from '../../components/coaching/StudentManagement';

const StudentManagementPage = () => {
  const { userProfile } = useRealtime();
  
  // Get coaching ID from user profile
  const coachingId = userProfile?.coachingId || 'default-coaching-id';

  return (
    <div className="max-w-7xl mx-auto">
      <StudentManagement coachingId={coachingId} />
    </div>
  );
};

export default StudentManagementPage;
